import {lazy, Suspense} from 'react'
import type {User} from '../lib/auth'
import {mt} from '../lib/i18n'

const Admin = lazy(() => import('../components/Admin'))

/** Navigation only. Every management API independently checks capabilities. */
export default function BackOffice({user}: {user: User}) {
  if (!user.capabilities.includes('admin.access')) {
    return <section className="page-intro"><h1>{mt('backOffice')}</h1><p role="alert">{mt('backOfficeDenied')}</p><a href="#/">{mt('browse')}</a></section>
  }
  return <section className="page-intro"><h1>{mt('backOffice')}</h1><Suspense fallback={<p>{mt('loading')}</p>}><Admin/></Suspense></section>
}
